export const contactEmail = 'tuckerc72xs650@gmail.com';

export const spotifyArtistUrl = 'https://open.spotify.com/artist/2xAmIqdDKfR1ArMKdlWdhA';

export const facebookPageUrl = 'https://www.facebook.com/staticrift.fullguagerecords';

export const instagramPageUrl = 'https://www.instagram.com/static.rift.fullguagerecords?igsh=amw2Y3d1azhtdGtm';

export const youtubeMusicUrl = 'https://music.youtube.com/channel/UCjCkn8tRS8xiA-Zi5zCGQjg?si=WFn8JnJoYeaNqpP-';

export const appleMusicUrl = 'https://music.apple.com/artist/1845720816';

export const brandAssets = {
  logo: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/3t5aaqxb_1765656353440.jpg',
  heroBackground: 'https://images.unsplash.com/photo-1752830457659-5bf9b46aeb45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxtZXRhbCUyMGJhbmQlMjBsaXZlJTIwY29uY2VydCUyMGJsdWUlMjBsaWdodHxlbnwwfHx8fDE3ODA3Mjk5NDV8MA&ixlib=rb-4.1.0&q=85',
  aboutVideo: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/gwu4fe8g_1764445278077.mp4',
  madhouseCover: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/2ccx2o3c_photostudio_1761582469555%20%281%29%281%29.jpg',
  staticOathsCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/ardgaewh_photostudio_1780773781962.jpg',
  gasolineCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/s07rnq1o_1780531772161.png',
  voodooCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/lo2aiuzc_1777070023091.png',
  timeCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/nzcfdsfn_1778213547912.png',
  staticOathsTrackCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/olou5nmo_17767972137012.jpg',
  halosCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/pzja96rg_1780532533070.png',
  backInTheDayCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/b0zon47r_1778284048317.png',
  chainsCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/y5dszfrb_photostudio_1778566507985.png',
  devilsGameCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/blckieag_1768961271122.jpg',
  offTheClockCover: 'https://customer-assets.emergentagent.com/job_a10966b9-8aab-4477-a977-e0b74a8b395a/artifacts/1o3u510e_1777532401133.png'
};

export const albums = [
  {
    id: 'static-oaths',
    title: 'Statìc Oäths',
    label: 'Released May 29',
    type: 'Spotify Release',
    cover: brandAssets.staticOathsCover,
    summary: 'Welcome to the noise. Statìc Oäths is the blistering new 9-track album from heavy metal/thrash project Statìc Rîft. Merging old-school thrash velocity with the monolithic grooves of modern hard rock, this record is an uncompromising sonic assault from front to back.',
    tracks: [
      {
        title: 'Gasoline And Sin',
        spotifyUrl: 'https://open.spotify.com/track/6ROk8LI7RELhC4oEjFlPyg?si=BrjhpuGMTwG1APYmZ2kVWw',
        cover: brandAssets.gasolineCover
      },
      {
        title: 'Voo-doo Goddess',
        spotifyUrl: 'https://open.spotify.com/track/6HdYQLha4LmCRnz71gdz4t?si=EyttkremSDGVKn-s-NoaVA',
        cover: brandAssets.voodooCover
      },
      {
        title: 'Time',
        spotifyUrl: 'https://open.spotify.com/track/7sJSG85R3CPn7yxY0gBRQl?si=Z6rq6p0gSWOGu8rHZrQ9RQ',
        cover: brandAssets.timeCover
      },
      {
        title: 'Statìc Oäths',
        spotifyUrl: 'https://open.spotify.com/track/3jSPCMwCiD4Njfi6amOUQ7?si=VGNYtWrST0abXqS_DdEjyQ',
        cover: brandAssets.staticOathsTrackCover
      },
      {
        title: 'Halos Of Barbed Wire',
        spotifyUrl: 'https://open.spotify.com/track/5XQKSVls7PkS4yGfyLqJB8?si=8rFhXb3VRzK6UJ_5H6LCRA',
        cover: brandAssets.halosCover
      },
      {
        title: 'Back In The Day',
        spotifyUrl: 'https://open.spotify.com/track/3LnnqvwP1LTHXwcZi5d9bB?si=IpzOvFoTReOjZdEAhkIPbw',
        cover: brandAssets.backInTheDayCover
      },
      {
        title: 'Chains Of The Life I Outran',
        spotifyUrl: 'https://open.spotify.com/track/5AcIsGBgMpTjzVn6JjWYlV?si=QytyscAuT9W57LmgyaIQEw',
        cover: brandAssets.chainsCover
      },
      {
        title: "The Devil's Game",
        spotifyUrl: 'https://open.spotify.com/track/6VWhvvZ05eYWKImC3xfnaB?si=WoJlhl1xTWCdEBWydYdcPg',
        cover: brandAssets.devilsGameCover
      },
      {
        title: 'Off The Clock',
        spotifyUrl: 'https://open.spotify.com/track/1rgPDP3I10SJsdJTcy3Srj?si=eLrmk8PZSBaGLxiFNYQ28Q',
        cover: brandAssets.offTheClockCover
      }
    ]
  },
  {
    id: 'the-madhouse',
    title: 'The Madhouse',
    label: 'First Album Release',
    type: 'Website Player',
    cover: brandAssets.madhouseCover,
    summary: 'The first release, available directly in the site player.',
    tracks: [
      {
        title: 'Welcome To The Madhouse',
        audioUrl: '/audio/welcome-to-the-madhouse.mp3'
      },
      {
        title: 'Savage Heart',
        audioUrl: '/audio/savage-heart.mp3'
      },
      {
        title: 'Beautiful Disaster',
        audioUrl: '/audio/beautiful-disaster.mp3'
      },
      {
        title: 'Live Your Life',
        audioUrl: '/audio/live-your-life.mp3'
      },
      {
        title: 'The Next Go Round',
        audioUrl: '/audio/the-next-go-round.mp3'
      },
      {
        title: 'Never Stopped Loving You',
        audioUrl: '/audio/never-stopped-loving-you.mp3'
      },
      {
        title: 'Seize The Day',
        audioUrl: '/audio/seize-the-day.mp3'
      }
    ]
  }
];

export const merchItems = [
  {
    id: 'electric-skull-tee',
    name: 'Electric Skull Tee',
    price: '$29.99',
    image: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/2pxrrv92_photostudio_1768076026311.png'
  },
  {
    id: 'static-rift-logo-tee',
    name: 'Statìc Rîft Logo Tee',
    image: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/6fxv7dfd_1768982574685.jpg',
    price: '$29.99'
  },
  {
    id: 'madhouse-tee',
    name: 'The Madhouse Tee',
    image: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/9dww5i68_1765656304480.jpg',
    price: '$29.99'
  },
  {
    id: 'static-rift-sticker',
    name: 'Statìc Rîft Sticker',
    image: 'https://customer-assets.emergentagent.com/job_71272d18-9881-41f6-9976-01230b3a0d9c/artifacts/dcffsrxq_1768330115445.jpg',
    price: '$5.99'
  }
];